/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Trainer_Services_DescriptionInputs */

const en_seo_trainer_services_description = /** @type {(inputs: Seo_Trainer_Services_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: sessions with their length, price and open times. Book online.`)
};

const pl_seo_trainer_services_description = /** @type {(inputs: Seo_Trainer_Services_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: zajęcia, czas trwania, ceny i wolne terminy. Zarezerwuj online.`)
};

/**
* | output |
* | --- |
* | "{name}: sessions with their length, price and open times. Book online." |
*
* @param {Seo_Trainer_Services_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_trainer_services_description = /** @type {((inputs: Seo_Trainer_Services_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Trainer_Services_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_trainer_services_description(inputs)
	return en_seo_trainer_services_description(inputs)
});